import ProfileFieldItem, {
  ProfileFieldItemAttributes
} from './ProfileFieldItem';

export enum ProfileFieldType {
  TEXT = 0,
  NUMBER = 1,
  DATE = 2,
  IMAGE = 3,
  TEXTLIST = 4 // support multi-text fields
}

interface ProfileField {
  profilekey: number;
  fieldposition: number;
  title: string;
  type: ProfileFieldType;
  required: boolean;
  created: Date;
  modified: Date;
  items: ProfileFieldItem[]; // * Drop-down options
}

export interface ProfileFieldUpdate {
  profilekey: number;
  fieldposition: number;
  type: number;
  items: ProfileFieldItemAttributes[];
}

export default ProfileField;
